import { addDays as addDaysFns } from 'date-fns';

export default function addDays(date: Date, days: number): Date {
  return addDaysFns(date, days);
}
